import { render, staticRenderFns } from "./RecoveryCertification.vue?vue&type=template&id=fed6268a&"
import script from "./RecoveryCertification.vue?vue&type=script&lang=js&"
export * from "./RecoveryCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports